import { useTexts } from '../useTexts'

const companyNameMaxLength = 250

export const createValidateName = async (texts: ReturnType<typeof useTexts>, name: string) => {
  const nameRequiredError = {
    id: 'nameRequiredError',
    field: 'name',
    message: texts.errorName,
  }

  const nameMaxLengthError = {
    id: 'nameMaxLengthError',
    field: 'name',
    message: texts.errorMaxLengthName,
  }
  const required = name.trim().length === 0

  const invalid = name.length > companyNameMaxLength

  return {
    [nameRequiredError.id]: required ? nameRequiredError : undefined,
    [nameMaxLengthError.id]: invalid ? nameMaxLengthError : undefined,
  }
}
